import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { buildActivityNoteTagHighlightHtml } from '../utils/activity-note-tag-highlight';

@Pipe({ name: 'activityNoteTagHighlight' })
export class ActivityNoteTagHighlightPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(
      buildActivityNoteTagHighlightHtml(value ?? '')
    );
  }
}
